<template>
    <div class="queue-add">
        <div class="queue-add__header">
            <h5 class="queue-add__header-title">Manage Queue Item</h5>
        </div>
        <div class="container-fluid pt-4 pb-4">
            <div class="row">
                <div class="col-lg-8">
                    <div class="card queue-add__card">
                        <div class="queue-add__title"><i class="far fa-user-plus"></i> Add Queue Item <button
                                type="button" class="btn btn-sm btn-light-success float-right" data-toggle="modal"
                                data-target="#studentLookup" @click="clearStudentNumber()">
                                <i class="far fa-search"></i> Lookup
                            </button></div>
                        <div class="card-body">
                            <transition name="fade">
                                <div v-if="queueAddStatus">
                                    <div v-if="queueAddType == 'danger'" class="alert alert-danger" role="alert">
                                        <i class="far fa-bell"></i> {{ queueAddMessage }}
                                    </div>
                                    <div v-else-if="queueAddType == 'warning'" class="alert alert-warning" role="alert">
                                        <i class="far fa-exclamation-triangle"></i> {{ queueAddMessage }}
                                    </div>
                                </div>
                            </transition>
                            <form id="formAddQueueItem">
                                <input type="hidden" name="mode" id="mode" value="addItem">
                                <input type="hidden" name="department" id="department" :value="getDepartment">
                                <input type="hidden" id="emailid" name="emailid" v-model="queueItem.emailid">
                                <div class="form-group">
                                    <label for="name">Name </label><small
                                        class="ml-1 font-weight-bold text-danger">*Required</small>
                                    <input type="text" class="form-control form-control-sm" id="name" name="name"
                                        v-model="queueItem.name" aria-describedby="name" placeholder="Enter name">
                                </div>
                                <div class="form-group">
                                    <label for="emplid">Student Number </label><small
                                        class="ml-1 font-weight-bold text-danger">*Required</small>
                                    <input type="text" class="form-control form-control-sm" id="emplid" name="emplid"
                                        v-model="queueItem.emplid" aria-describedby="student number"
                                        placeholder="Enter student number" @input="getStudentNumber()">
                                </div>
                                <div class="form-group">
                                    <label for="username">Western Email </label><small
                                        class="ml-1 font-weight-bold text-danger">*Required</small>
                                    <div class="input-group input-group-sm">
                                        <input type="text" :maxlength="8" class="form-control form-control-sm"
                                            aria-describedby="username" id="username" name="username"
                                            v-model="queueItem.username" placeholder="Enter western email"
                                            @input="getUsernameAndEmail()">
                                        <div class="input-group-append">
                                            <span class="input-group-text">@uwo.ca</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="program">Student Program </label>
                                    <input type="text" class="form-control form-control-sm" id="program" name="program"
                                        v-model="queueItem.program" aria-describedby="program"
                                        placeholder="Enter program">
                                </div>
                                <div class="form-group">
                                    <label for="counsellor">Counsellor</label>
                                    <select class="form-control form-control-sm" id="counsellor" name="counsellor"
                                        v-model="queueItem.counsellor">
                                        <option value="">None</option>
                                        <option v-for="counsellor in counsellorsData" :key="counsellor.username"
                                            :value="counsellor.username"> {{ counsellor.commonName }}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="appointmentType">Appointment Type</label>
                                    <select v-model="queueItem.appointmentType" class="form-control form-control-sm"
                                        id="appointmentType" name="appointmentType">
                                        <option value="">None</option>
                                        <option value="inperson">In-person</option>
                                        <option value="virtual">Virtual</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="waitingArea">Waiting Area</label>
                                    <select class="form-control form-control-sm" id="waitingArea" name="waitingArea"
                                        v-model="queueItem.waitingArea">
                                        <option value="">Not Assigned</option>
                                        <option v-for="(waitingArea, i) in waitingAreasData" :key="i"
                                            :value="waitingArea.value"> {{ waitingArea.label }}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="w-100 mb-0" for="notes">Reason for visit/Additional
                                        notes</label>
                                    <small class="float-right">Remaining length: {{ maxNotesLength }}</small>
                                    <textarea class="form-control" id="notes" name="notes" :maxlength="256" rows="5"
                                        v-model="queueItem.notes"
                                        placeholder="Enter reason for visit and/or additional notes"></textarea>
                                </div>
                            </form>
                            <div class="queue-add__menu">
                                <button type="button" class="btn btn-sm btn-primary" @click="addQueueItem()"
                                    :disabled="getRequiredFields">
                                    <i v-if="queueAddLoad" class="fas fa-spinner fa-spin"></i>
                                    <i v-else class="far fa-plus"></i>
                                    Add</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="studentLookup" tabindex="-1" role="dialog" aria-labelledby="studentLookup"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="studentLookup">Lookup Student</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <i class="far fa-search fa-2x icon__success"></i> Please enter a valid student number or swipe
                        student card.
                        <form id="formStudentLookup">
                            <div class="form-group mt-2 mb-0">
                                <label for="id" class="queue-add__label">Student Number</label>
                                <input type="text" class="form-control form-control-sm" id="id" name="id"
                                    v-model="studentNumber" aria-describedby="student number"
                                    placeholder="Enter student number" @keydown.enter.prevent="getStudent()"
                                    @input="validateStudentNumber()">
                            </div>
                            <div v-if="studentLookupStatus" class="queue-add__alert--danger">
                                <i class="far fa-exclamation-circle"></i> The student could not be found.
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" @click="getStudent"><i
                                v-if="studentLookupLoad" class="fas fa-spinner fa-spin"></i> Lookup</button>
                        <button type="button" ref="close" class="btn btn-sm btn-warning"
                            data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    setTimeout
} from 'timers';

const DEPARTMENT = `Academic Dean's Office`;

export default {
    name: 'queue-add',
    data() {
        return {
            counsellorsData: [],
            counsellorsResult: '',
            queueAddAlert: '',
            queueAddLoad: false,
            queueAddMessage: '',
            queueAddStatus: false,
            queueAddType: '',
            queueItem: {
                appointmentType: '',
                counsellor: '',
                emailid: '',
                emplid: '',
                itemid: '',
                name: '',
                notes: '',
                number: '',
                program: '',
                username: '',
                waitingArea: ''
            },
            queueLoadStatus: true,
            queueAddMessage: '',
            queueAddStatus: true,
            studentLookupLoad: false,
            studentLookupStatus: false,
            studentNumber: '',
            waitingAreasData: []
        }
    },
    methods: {
        addQueueItem() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl`;
            const formRef = document.getElementById('formAddQueueItem');
            const formData = new FormData(formRef);
            this.queueAddLoad = true;

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Success
                if (json.result.match(/success/i)) {
                    // Redirect to dashboard
                    that.$router.push({
                        path: '/ado/admin'
                    })
                } else if (json.result.match(/in-queue/i)) {
                    // Set duplicate error message
                    that.queueAddMessage = 'You are unable to add this student. It seems that this student is already in queue.';
                    that.queueAddType = 'warning';
                    that.queueAddStatus = true;
                } else {
                    // Set fail message
                    that.queueAddMessage = 'An issue occurred when adding this student. Please contact your system administrator.';
                    that.queueAddType = 'danger';
                    that.queueAddStatus = true;
                }

                that.queueAddLoad = false;
            }).catch(function (error) {
                // Fail
                that.queueAddMessage = 'An issue occurred when adding this student. Please contact your system administrator.';
                that.queueAddType = 'danger';
                that.queueAddStatus = true;
                that.queueAddLoad = false;
            })

            if (!this.queueAddAlert) {
                this.queueAddAlert = setTimeout(function () {
                    that.queueAddAlert = '';
                    that.queueAddMessage = '';
                    that.queueAddStatus = false;
                    that.queueAddType = '';
                }, 5000);
            }
        },
        clearStudentNumber() {
            this.studentNumber = '';
            this.studentLookupStatus = false;
        },
        getCounsellors() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getCounsellorsData&department=${DEPARTMENT}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Store counsellors
                    if (json.result.match(/^OK/i)) {
                        that.counsellorsData = json.data || that.counsellorsData;
                        that.waitingAreasData = json.waitingAreas || that.waitingAreasData;
                    } else {
                        that.counsellorsResult = 'ERROR';
                    }
                })
                .catch(function (error) {
                    that.counsellorsResult = 'ERROR';
                })
        },
        getStudent() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?lookup&id=${this.studentNumber}&department=${DEPARTMENT}`;
            this.studentLookupLoad = true;
            this.studentLookupStatus = false;

            // GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Store counsellors
                    if (json.result.match(/^OK/i)) {
                        // Set form values
                        that.queueItem.name = json.student.name;
                        that.queueItem.emplid = json.student.emplid;
                        that.queueItem.username = json.student.username;
                        that.queueItem.emailid = json.student.emailid;

                        // Close modal
                        that.$refs.close.click();
                    } else {
                        that.studentLookupStatus = true;
                    }

                    that.studentLookupLoad = false;
                })
                .catch(function (error) {
                    that.studentLookupLoad = false;
                })
        },
        getStudentNumber() {
            let studentNumber = this.queueItem.emplid;
            studentNumber = studentNumber.replace(/\D/g, '');
            studentNumber = studentNumber.match(/^\d{0,9}/);

            // Set student number
            this.queueItem.emplid = studentNumber[0] || '';
        },
        getUsernameAndEmail() {
            this.queueItem.username = this.queueItem.username.toLowerCase();
            this.queueItem.emailid = this.queueItem.username + '@uwo.ca';
        },
        validateStudentNumber() {
            var value = this.studentNumber.replace(/\D/gi, '');
            value = this.studentNumber.match(/^\d{0,9}/);
            this.studentNumber = value[0];
        }
    },
    computed: {
        getDepartment() {
            // Return resolved department
            return DEPARTMENT;
        },
        getRequiredFields() {
            // Submission required fields
            if (this.queueItem.name && this.queueItem.emplid.length == 9 && this.queueItem.emailid && this.queueItem
                .username) {
                return false;
            }

            return true;
        },
        maxNotesLength() {
            // Limit max notes field length
            if (this.queueItem.notes && this.queueItem.notes.length) {
                return 256 - this.queueItem.notes.length;
            }

            return 256;
        }
    },
    created() {
        // Retrieve list of counsellors
        this.getCounsellors();
    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.modal-body {
    font-size: 14px;
}

.modal-title {
    font-weight: 600;
    font-size: 1rem;
    color: #48465b;
}

.queue-add__alert--danger {
    color: #dc3545;
    font-weight: 600;
}

.queue-add__card {
    border: none;
    color: #595d6e;
    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
}

.queue-add__header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #434349;
    padding: 1rem;
    background-color: #fff;
    -webkit-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
}

.queue-add__label {
    font-weight: 600;
    margin: 0;
}

.queue-add__menu {
    text-align: right;
}

.queue-add__header-title {
    font-weight: 600;
    margin: 0;
}

.queue-add__load {
    color: #5d78ff;
    text-align: center;
}

.queue-add__title {
    border-bottom: 1px solid #ebedf2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #48465b;
    font-size: 16px;
    font-weight: 700;
    padding: 16px 20px;
}
</style>